import { render, staticRenderFns } from "./variant-selector.vue?vue&type=template&id=2442149c&scoped=true&lang=pug&"
import script from "./variant-selector.vue?vue&type=script&lang=coffee&"
export * from "./variant-selector.vue?vue&type=script&lang=coffee&"
import style0 from "./variant-selector.vue?vue&type=style&index=0&id=2442149c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2442149c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormButtonGroup: require('/opt/build/repo/library/components/globals/form/button-group.vue').default})
